import { z } from 'zod';
import { ClaimDataSourceSchema } from './base.js';
export const CustomerCommunicationTypeSchema = z.enum([
    'customerContactedEmail',
    'customerContactedLvm',
    'customerContactedNoVoicemail',
    'customerContactedSms',
    'customerNoContact',
    'initialCustomerContactAttempted',
    'initialCustomerContactFailed',
    'initialCustomerContactSuccess',
    'invalidContactInformation',
]);
export const CustomerCommunicationRoleEnumSchema = z.enum(['inspector', 'coordinator', 'external']);
export const CustomerCommunicationRole = CustomerCommunicationRoleEnumSchema.enum;
export const CustomerCommunicationSchema = z.object({
    createdBy: z.string().optional(),
    dataSource: ClaimDataSourceSchema.or(z.string()).optional(),
    date: z.string().datetime(),
    type: CustomerCommunicationTypeSchema,
    role: CustomerCommunicationRoleEnumSchema.optional(),
});
export const CustomerCommunicationTypeEnum = CustomerCommunicationTypeSchema.enum;
export const CuratedCustomerCommunicationTypeSchema = z.enum([
    CustomerCommunicationTypeEnum.customerContactedEmail,
    CustomerCommunicationTypeEnum.customerContactedLvm,
    CustomerCommunicationTypeEnum.customerContactedNoVoicemail,
    CustomerCommunicationTypeEnum.customerContactedSms,
    CustomerCommunicationTypeEnum.initialCustomerContactSuccess,
    CustomerCommunicationTypeEnum.invalidContactInformation,
]);
